module.exports = __webpack_public_path__ + "static/media/mobile.8d7e92cb.svg";